import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzSpinModule],
  selector: 'ui-spinner',
  template: `
    <nz-spin [nzSpinning]="isLoading()">
      <ng-content></ng-content>
    </nz-spin>
  `,
})
export class SpinnerComponent {
  isLoading = input(false);
}
